import {Action, Selector, State, StateContext} from '@ngxs/store';
import {Injectable} from '@angular/core';
import {GeneralContractHeader} from '../../models/api/product/general-contract-header.model';
import {GraphActions} from './graph.actions';
import {ReportService} from '../../services/report.service';
import {AutocompleteService} from '../../services/autocomplete.service';
import {map} from 'rxjs/operators';
import {SalesReport} from '../../models/api/sales-report.model';
import {SalesReportParams} from '../../models/api/sales-report-params.model';

interface GraphStateModel {
    generalContractList: GeneralContractHeader[];
    salesReport: SalesReport;
    salesReportParams: SalesReportParams;
}

@State<GraphStateModel>({
    name: GraphState.STATE_NAME,
    defaults: {
        generalContractList: null,
        salesReport: null,
        salesReportParams: null,
    },
})
@Injectable()
export class GraphState {
    static readonly STATE_NAME = 'graph';

    constructor(private reportService: ReportService, private autocompleteService: AutocompleteService) {}

    @Selector()
    static generalContractList(state) {
        return state.generalContractList;
    }

    @Selector()
    static salesReport(state) {
        return state.salesReport;
    }

    @Selector()
    static salesReportParams(state) {
        return state.salesReportParams;
    }

    @Action(GraphActions.Clear)
    graphClear(ctx: StateContext<GraphStateModel>) {
        ctx.patchState({
            generalContractList: null,
            salesReport: null,
            salesReportParams: null,
        });
    }

    @Action(GraphActions.ClearGeneralContractList)
    graphClearGeneralContractList(ctx: StateContext<GraphStateModel>) {
        ctx.patchState({
            generalContractList: null,
        });
    }

    @Action(GraphActions.SearchGeneralContracts)
    searchGeneralContracts(ctx: StateContext<GraphStateModel>, {phrase}: GraphActions.SearchGeneralContracts) {
        return this.autocompleteService
            .getGeneralContracts(phrase)
            .pipe(map((generalContractList) => ctx.patchState({generalContractList})));
    }

    @Action(GraphActions.GetSales)
    getSales(ctx: StateContext<GraphStateModel>, {filters}: GraphActions.GetSales) {
        return this.reportService
            .getSales(filters)
            .pipe(map((salesReport) => ctx.patchState({salesReport, salesReportParams: filters})));
    }
}
